/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useEffect, useState } from "react";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/use-auth";
import Config from "data/config";
// import { Logger } from "cms/utils/log/logger";

const WebpageFeature = (props) => {
    
    const { value } = props || {};
    const { token } = useAuth();
    const [webpageGuid, setWebpageGuid] = useState();
    const [webpage, setWebpage] = useState();
    
    useEffect(() => {
        const fetchWebpage = async () => {
            if (value && webpageGuid !== value) {
                let current_webpage = await SimpliCityAdminSDK.webpage.findOne(token, value);
                if (current_webpage && current_webpage.guid) {
                    setWebpage(current_webpage);
                    setWebpageGuid(current_webpage.guid);
                    // Logger.debug('setWebpage', current_webpage)
                } else {
                    // Logger.debug('Could not load webpage...', value)
                }
            } else {
                setWebpage(undefined);
            }
        };
        fetchWebpage();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);
    
    return (
        <Fragment>
            { webpage &&
                <div className="views-row views-row-1 views-row-odd views-row-first">
                    <div className="views-field views-field-field-link">
                        <div className="field-content">
                            <a href={`${Config.previewUrl}${webpage.path}`}
                                style={{
                                    fontFamily: "\"Avenir LT W01_85 Heavy1475544\",\"Helvetica Neue\",Arial,sans-serif",
                                    fontSize: "17px",
                                    color: "#000",
                                    display: "inline-block",
                                    clear: "both",
                                    marginBottom: "1.75rem",
                                    position: "relative",
                                    paddingLeft: "3rem",
                                }}
                                className="featured-service__link"
                            >
                                <span className={`featured-service__icon far ${webpage.nav_icon}`}
                                    style={{
                                        fontFamily: "Font Awesome 5 Pro",
                                        fontWeight: "400",
                                        // -webkit-font-smoothing: antialiased;
                                        display: "inline-block",
                                        fontStyle: "normal",
                                        fontVariant: "normal",
                                        textRendering: "auto",
                                        lineHeight: 1,
                                        fontSize: "1.625rem",
                                        position: "absolute",
                                        top: "50%",
                                        left: "0",
                                        // -webkit-transform: translate(0,-50%);
                                        // -ms-transform: translate(0,-50%);
                                        transform: "translate(0,-50%)",
                                        color: "#004F59",
                                        // -webkit-transition: color 0.2s ease-in-out;
                                        // -o-transition: color 0.2s ease-in-out;
                                        transition: "color 0.2s ease-in-out",
                                    }}
                                >
                                </span>
                                <span className="featured-service__text">{webpage.nav_title}</span>
                            </a>
                            {/*<Highlight webpage={webpage} style={style} options={options} onClickHandler={onClickHandler} />*/}
                        </div>
                    </div>
                </div>
            }
        </Fragment>
    );
};
export default WebpageFeature;
